import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

const Hero = () => {
  const skills = [
    'Node',
    'React',
    'C#',
    'TailwindCSS',
    'Github',
    'SQL',
    'MongoDB',
    'Typescript',
    'SQL Server',
    'Prisma ORM',
    'NextJS',
    'Python',
    'MySQL',
  ];

  return (
    <section className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden px-4">
      {/* Animated background gradient orbs */}
      <div className="absolute top-20 left-20 w-72 h-72 bg-purple-600/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="relative z-10 text-center max-w-[100%]">
        {/* Main heading */}
        <h1 className="text-5xl md:text-9xl font-bold mb-6 tracking-tight">
          <span className="bg-gradient-to-r from-purple-400 via-purple-300 to-cyan-400 bg-clip-text text-transparent">
            Warren Jonas
          </span>
        </h1>

        <p className="text-2xl md:text-3xl text-zinc-400 mb-12 font-light tracking-wide text-wrap">
          Full Stack Developer & Aspiring Cybersecurity Analyst
        </p>

        {/* Social links */}
        <div className="flex gap-6 justify-center mb-16">
          <a
            href="https://github.com/warjonas"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-lg bg-zinc-900/50 border border-zinc-800 hover:border-purple-500/50 hover:bg-zinc-800/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20"
          >
            <Github className="w-6 h-6 text-zinc-400 hover:text-purple-400 transition-colors" />
          </a>
          <a
            href="www.linkedin.com/in/warren-jonas-9444aa212"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-lg bg-zinc-900/50 border border-zinc-800 hover:border-cyan-500/50 hover:bg-zinc-800/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20"
          >
            <Linkedin className="w-6 h-6 text-zinc-400 hover:text-cyan-400 transition-colors" />
          </a>
          <a
            href="mailto:jonaswarren9@example.com"
            className="p-3 rounded-lg bg-zinc-900/50 border border-zinc-800 hover:border-purple-500/50 hover:bg-zinc-800/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20"
          >
            <Mail className="w-6 h-6 text-zinc-400 hover:text-purple-400 transition-colors" />
          </a>
        </div>

        {/* Skills marquee */}
        <div className="relative overflow-hidden py-4">
          <div className="flex animate-marquee whitespace-nowrap">
            {[...skills, ...skills, ...skills].map((skill, index) => (
              <span
                key={index}
                className="mx-4 text-lg md:text-xl font-medium text-zinc-500 hover:text-purple-400 transition-colors cursor-default"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
